import { render, staticRenderFns } from "./TransationDetailComponent.vue?vue&type=template&id=5e90ee0a&scoped=true&"
import script from "./TransationDetailComponent.vue?vue&type=script&lang=js&"
export * from "./TransationDetailComponent.vue?vue&type=script&lang=js&"
import style0 from "./TransationDetailComponent.vue?vue&type=style&index=0&id=5e90ee0a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e90ee0a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBreadcrumbs } from 'vuetify/lib/components/VBreadcrumbs';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBreadcrumbs,VCol,VContainer,VDivider,VIcon,VRow})
